<template>
  <div class="d-flex align-center py-3 set-editable-row">
    <div class="flex-grow-1 text-body-1 font-weight-medium">
      {{ label }}
    </div>

    <time-drum-picker
      class="mr-3"
      :value="startAt"
      :step="5"
      @input="onStartTimeInput"
    />

    <v-text-field
      :value="price"
      type="number"
      hide-details
      outlined
      style="max-width: 140px;"
      class="set-input"
      @input="onPriceInput"
    />
    <span class="mx-2 text-body-1">円</span>

    <v-btn-toggle
      :value="taxCharge"
      mandatory
      class="ml-3 tax-charge-toggle"
      @change="$emit('update:taxCharge', $event)"
    >
      <v-btn
        large
        value="normal"
      >
        通常
      </v-btn>
      <v-btn
        large
        value="cut"
      >
        カット
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import TimeDrumPicker from './TimeDrumPicker.vue'

export default {
  name: 'SetEditableRow',
  components: { TimeDrumPicker },
  props: {
    label: { type: String, required: true },
    price: { type: Number, default: 0 },
    taxCharge: { type: String, default: 'normal' },
    startAt: { type: Date, default: null },
  },
  emits: ['update:price', 'update:taxCharge', 'update:startAt'],
  setup(_, { emit }) {
    const onPriceInput = v => {
      emit('update:price', Number(v) || 0)
    }

    const onStartTimeInput = d => {
      if (!(d instanceof Date)) return
      emit('update:startAt', d)
    }

    return { onPriceInput, onStartTimeInput }
  },
}
</script>

<style scoped>
.set-editable-row {
  border-bottom: 1px solid rgba(127, 127, 127, 0.12);
}
.set-input :deep(input) {
  font-size: 1.1rem;
  text-align: right;
}
</style>
